<template>
  <div id="historic">
    <div class="title">
      <i class="fa fa-history tab-ico"/>{{ $t("history") + ' - ' + code }}
    </div>

    <!-- * Loader -->
    <load-screen :notFullScreen="true" v-show="loadingList"></load-screen>

    <!-- * Table -->
    <table v-show="!loadingList" class="custom-table" style="margin: auto">
      <thead>
        <tr>
          <th>{{ $t('date') }}</th>
          <th>{{ $t('user') }}</th>
          <th>{{ $t('status') }}</th>
          <th v-if="company!='bw'">{{ $t('reason') }}</th>
          <th>{{ $t('modified_fields') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(record, index) in paginatedHistoric" :key="index">
          <td>{{ record.created | moment('D/M/YYYY - HH:mm') }}</td>
          <td>{{ users.get(record.user) || $t('unknown_user') }}</td>
          <td>{{ $t(status.get(record.status) + '') }}</td>
          <td v-if="company !== 'bw'">{{ $t(reasons.get(record.reason) + '') }}</td>
          <td :class="record.modified_fields ? 'p-small' : 'p-default'">
            <table v-if="record.modified_fields" class="inner-table">
              <thead>
                <tr>
                  <th>{{ $t('field') }}</th>
                  <th>{{ $t('old_value') }}</th>
                  <th>{{ $t('new_value') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(change, field) in record.modified_fields" :key="field">
                  <td><strong>
                    {{
                      field === 'company_notes' ? (trw ? $t('k_notes_trw', [$t(company)]) : $t('k_notes')) :
                      field === 'action_date' && type === 'reception' ? $t('date_download') :
                      field === 'action_date' && type === 'expedition' ? $t('date_load') :
                      field === 'booked_date' ? $t('date_in') :
                      $t(field)
                    }}
                  </strong></td>
                  <td>{{ change.old === '' || change.old === null ? '---' : change.old }}</td>
                  <td>{{ change.new === '' || change.new === null ? '---' : change.new }}</td>
                </tr>
              </tbody>
            </table>
            <div v-else>
              {{ $t('no_changes') }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- * Pagination -->
    <div id="pages" v-if="totalPages > 1">
      <div class="move-page" @click="page > 1 && fillPage(page - 1)">« {{ $t('prev') }}.</div>
      <div
        v-for="pageNumber in pagesShown"
        :key="pageNumber"
        :class="page === pageNumber ? 'selected-page' : 'page'"
        @click="fillPage(pageNumber)">
        {{ pageNumber }}
      </div>
      <div class="move-page" @click="page < totalPages && fillPage(page + 1)">{{ $t('next') }}. »</div>
    </div>

    <!-- * Buttons -->
    <div class="buttons">
      <button class="btn-black" @click="$emit('close')">{{$t('cancel')}}</button>
    </div>
  </div>
</template>

<script>
import LoadScreen from './LoadScreen'
import { mapActions } from 'vuex'
export default {
  name: 'historic',
  components: {
    LoadScreen
  },
  props: ['shipment', 'code', 'type', 'trw', 'company'],
  data () {
    return {
      reasons: new Map(),
      status: new Map(),
      users: new Map(),

      loadingList: true,

      historic: [],

      pageSize: 10,
      page: 1
    }
  },
  computed: {
    paginatedHistoric () {
      const start = (this.page - 1) * this.pageSize
      return this.historic.slice(start, start + this.pageSize)
    },
    totalPages () {
      return Math.ceil(this.historic.length / this.pageSize)
    },
    pagesShown () {
      const pages = [this.page]
      for (let i = 1; i <= 2; i++) {
        if (this.page - i > 0) pages.push(this.page - i)
        if (this.page + i <= this.totalPages) pages.push(this.page + i)
      }
      return pages.sort((a, b) => a - b)
    }
  },
  watch: {
    show (newVal) {
      if (newVal) this.fetchHistoricData()
    }
  },
  mounted () {
    if (this.shipment) this.fetchInitialData()
  },
  methods: {
    ...mapActions({
      getReasons: 'listes/rawReasons',
      getHistoric: 'lines/historic',
      getStatus: 'listes/status',
      getUsers: 'user/list'
    }),
    fillPage (pageNumber) {
      this.page = pageNumber
    },

    // Async methods
    async fetchInitialData () {
      try {
        await Promise.all([
          this.getReasons().then(response => { this.reasons = new Map(response.map(x => [x.id, x.description])) }),
          this.getStatus().then(response => { this.status = new Map(response.map(x => [x.id, x.description])) }),
          this.getUsers({ page: 1 }).then(response => { this.users = new Map(response.map(x => [x.user.id, (x.user.first_name || x.user.last_name) ? `${x.user.first_name || ''} ${x.user.last_name || ''}`.trim() : x.user.username])) }),
          this.fetchHistoricData()
        ])
        this.$emit('loaded')
      } catch (error) {
        console.error('Error loading initial data:', error)
      }
    },
    async fetchHistoricData () {
      try {
        const response = await this.getHistoric(this.shipment)
        this.loadingList = false
        this.historic = response
        console.log(this.historic)
      } catch (error) {
        console.error('Error fetching historic data:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/variables.scss';
#historic {
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.1);
}
.title {
  font-size: 1.5rem;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
  .center {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  i {
    margin-right: 0.5rem;
    color: #009D97;
  }
}
table {
  width: 100%;
  height: 100%;
  th, td {
    vertical-align: middle;
  }
  th {
    text-align: center;
    font-weight: normal;
    color: #333;
  }
  td {
    padding: 1rem;
    background: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  }
  tr:hover td {
    background-color: #F4F7FA;
  }
}
.buttons {
  display: flex;
  justify-content: center;
  margin-top: 1em;
  gap: 10px;
  .btn-green:hover {
    background-color: #e8ee8f;
  }
  .btn-blue:hover {
    background-color: #5ab9b9;
  }
  .btn-black:hover {
    background-color: #5e5e5e;
  }
}
.p-small {
  padding: .25rem;
}
.p-default {
  padding: 1rem;
}
.inner-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  th, td {
    border: 1px solid #ddd;
    padding: 2px;
  }
  th {
    background-color: #5ab9b9;
    color: #fff;
    text-align: center;
  }
  td {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Historic.vue